import {ChangeDetectionStrategy, Component} from '@angular/core'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {TranslocoDirective} from '@ngneat/transloco'
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle'

@Component({
  selector: 'bgo-value-checkmarks',
  imports: [FaIconComponent, TranslocoDirective],
  templateUrl: './buildigo-value-checkmarks.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuildigoValueCheckmarksComponent {
  protected readonly faCheck = faCheckCircle
}
